import {
  IInterviewerRatingDetails,
  IInterviewerRating,
  IUpdateSingleRatingPayload,
  TEvaluationRatings,
  ISubmitQuestionScoreResponse,
} from "@/types/interviewer.types";
import { HTTP_METHODS } from "@/constants/HttpConstants";
import { sendRequestToInterviewWithCredential } from "@/utils/request.utils";

export const getScorecardAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<TEvaluationRatings>({
    method: HTTP_METHODS.GET,
    url: `/interviews/${interviewSlug}/interviewer_feedback/`,
  });

export const createInterviewRatingsAPI = (
  interviewSlug: string,
  feedbackSlug: string,
  payload: IUpdateSingleRatingPayload,
) =>
  sendRequestToInterviewWithCredential<
    IInterviewerRatingDetails["evaluation_ratings"]
  >({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/interviewer_feedback/`,
    data: payload,
  });

export const updateSingleRatingAPI = (
  interviewSlug: string,
  feedbackSlug: string,
  payload: IUpdateSingleRatingPayload,
) =>
  sendRequestToInterviewWithCredential<
    IInterviewerRatingDetails["evaluation_ratings"]
  >({
    method: HTTP_METHODS.PATCH,
    url: `/interviews/${interviewSlug}/interviewer_feedback/${feedbackSlug}/`,
    data: payload,
  });

export const updateStatusAPI = (
  interviewSlug: string,
  feedbackSlug: string | null,
  body: IInterviewerRating,
) =>
  sendRequestToInterviewWithCredential<IInterviewerRatingDetails>({
    method: HTTP_METHODS.PATCH,
    url: `/interviews/${interviewSlug}/interviewer_feedback/${feedbackSlug}/`,
    data: body,
  });

export const submitQuestionScoreAPI = (
  interviewSlug: string,
  questionSlug: string,
  payload: { score: number; description?: string | null },
) =>
  sendRequestToInterviewWithCredential<ISubmitQuestionScoreResponse>({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/questions/${questionSlug}/score/`,
    data: payload,
  });

export const updateQuestionScoreAPI = (
  interviewSlug: string,
  questionSlug: string,
  payload: { score: number; description?: string | null },
) =>
  sendRequestToInterviewWithCredential<ISubmitQuestionScoreResponse>({
    method: HTTP_METHODS.PUT,
    url: `/interviews/${interviewSlug}/questions/${questionSlug}/score/`,
    data: payload,
  });
